import {NEW_ID} from '../../../../common/constants/index.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import api from '../../../../common/api.js'
import {
  formSelector,
  getState,
  onlyIfAutoForm,
  updateForm,
  useSelector,
} from '../../../../store.js'
import {setShipper} from '../../../../data/shippers.js'
import {showGlobalError} from '../../../GlobalErrorMessage.js'
import {PITNEY_PRESORT} from '../../../../common/constants/ShipperNames.js'
import {isPresent} from '../../../../common/utils.js'
import Nickname from './Nickname.js'
import ShippingMethods from './ShippingMethods.js'
import {
  baseSaveParamsSelector,
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  goToShipperSettings,
} from '../ShippersFunctions.js'
import className from '../../../../common/className.js'
import TextInput from '../../Common/TextInput.js'

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  const errors = baseShipperFormErrorsSelector(state, {formName})
  const form = formSelector(state, {
    formName,
  })

  if (!isPresent(form.pb_shipment_group_id)) {
    errors.pb_shipment_group_id = 'Shipment Group ID is required'
    errors.preventSave = true
  }

  if (!isPresent(form.pb_integrator_carrier_id)) {
    errors.pb_integrator_carrier_id = 'Integrator Carrier ID is required'
    errors.preventSave = true
  }

  return errors
}

export function initialFormSelector(state, {shipper}) {
  const vendorConfig = shipper?.vendor_config || {}

  return {
    ...baseShipperInitialFormSelector(state, {shipper, vendor: PITNEY_PRESORT}),
    pb_shipment_group_id: vendorConfig.pb_shipment_group_id || '',
    pb_integrator_carrier_id: vendorConfig.pb_integrator_carrier_id || '',
  }
}

export async function saveShipperPitneyPresort(formName) {
  const form = formSelector(getState(), {formName})
  let [shipperID, params] = baseSaveParamsSelector(getState(), {formName})

  const {pb_shipment_group_id, pb_integrator_carrier_id} = form

  params = {
    ...params,
    pb_shipment_group_id,
    pb_integrator_carrier_id,
  }

  updateForm(formName, {isSaving: true})

  try {
    const {json} =
      shipperID !== NEW_ID
        ? await api.put(`/shipper/${shipperID}/`, params)
        : await api.post('/shipper/', {...params, vendor: PITNEY_PRESORT})

    goToShipperSettings()

    setShipper(json)
  } catch (err) {
    showGlobalError(
      {
        summary: 'There was an error while saving shipper.',
      },
      err,
    )

    updateForm(formName, {isSaving: false})
  }
}

function PitneyPresortForm({formName, form}) {
  const {id, pb_shipment_group_id, pb_integrator_carrier_id, isSaving} = form
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  return (
    <div className="settings-list-item-form-wrap clear-both">
      <div className="medium-6 columns">
        <fieldset>
          <ul className="form-list margin-bottom-0">
            {id !== NEW_ID && <Nickname formName={formName} />}
            <li
              className={className`form-list-item bigger margin-bottom-20 ${{'margin-top-20 divider--top': form.id !== NEW_ID}}`}
            >
              <TextInput
                label="Shipment Group ID"
                name="pb_shipment_group_id"
                value={pb_shipment_group_id}
                onChange={(event) =>
                  updateForm(formName, {
                    pb_shipment_group_id: event.target.value,
                    hasChanged_pb_shipment_group_id: true,
                  })
                }
                errorMessage={
                  form.hasChanged_pb_shipment_group_id &&
                  errors.pb_shipment_group_id
                }
                required
              />
            </li>
            <li className="form-list-item bigger margin-bottom-20">
              <TextInput
                label="Integrator Carrier ID"
                name="pb_integrator_carrier_id"
                value={pb_integrator_carrier_id}
                onChange={(event) =>
                  updateForm(formName, {
                    pb_integrator_carrier_id: event.target.value,
                    hasChanged_pb_integrator_carrier_id: true,
                  })
                }
                errorMessage={
                  form.hasChanged_pb_integrator_carrier_id &&
                  errors.pb_integrator_carrier_id
                }
                required
              />
            </li>
            {id !== NEW_ID && <ShippingMethods formName={formName} />}
            <li className="list__item list__item--no-style">
              <ButtonPrimary
                onClick={() => saveShipperPitneyPresort(formName)}
                isDisabled={errors.preventSave}
                isLoading={isSaving}
              >
                {id !== NEW_ID ? 'Save' : 'Create'}
              </ButtonPrimary>
              <ButtonSecondary onClick={() => goToShipperSettings()}>
                Cancel
              </ButtonSecondary>
            </li>
          </ul>
        </fieldset>
      </div>
      {id === NEW_ID && (
        <div className="medium-5 columns">
          <fieldset>
            <div className="alert margin-bottom-10 alert--standard">
              <dl className="list">
                <dt className="list__title fs-00 lh-md margin-bottom-5">
                  Need help setting up your Pitney Presort account?
                </dt>
                <dd className="list__item fs-n0 margin-bottom-0">
                  Please contact{' '}
                  <a href="mailto:support@ordoro.com">support@ordoro.com</a> to
                  have this special shipper enabled in your account.
                  <div>
                    <a
                      className="btn--link mid meta-ups-setup-help"
                      href="https://support.ordoro.com/how-do-i-set-up-pitney-presort-in-ordoro/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      More info →
                    </a>
                  </div>
                </dd>
              </dl>
            </div>
          </fieldset>
        </div>
      )}
    </div>
  )
}

export default onlyIfAutoForm(PitneyPresortForm, setUpShipperForm)
